import styled from 'styled-components';

import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ActionMenu } from 'ui/actionMenu';
import {
  ActionMenuOption,
  AllowedActionMenuElements,
  MENU_ALIGNMENTS,
  MENU_DIRECTIONS,
} from 'ui/actionMenu/types';
import { ChevronDown } from 'ui/icons/navigation/ChevronDown';
import { NoOp } from 'utils/noop';

// expected as button & action menu together
const ComboButton = styled.div`
  display: flex;
  > *:not(:only-child) {
    &:first-child {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &:last-child button {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
`;
const ButtonLabel = styled.span`
  white-space: nowrap;
`;

export type Props = {
  actions: Partial<ActionMenuOption>[];
  label: string;
  onClick: NoOp;
  size?: BUTTON_SIZES;
  variant?: BUTTON_VARIANTS;
};

export const testIds = {
  actionMenu: 'df-action-button-combo-action-menu',
  button: 'df-action-button-combo-button',
};

export const ActionButtonCombo = ({
  actions = [],
  label,
  onClick,
  size = BUTTON_SIZES.LARGE,
  variant = BUTTON_VARIANTS.PRIMARY,
}: Props) => {
  const actionMenuOptions = actions.map((action) => {
    return {
      ...action,
      as: AllowedActionMenuElements.Button,
    };
  }) as ActionMenuOption[];

  return (
    <ComboButton>
      <Button data-test={testIds.button} onClick={onClick} size={size} variant={variant}>
        <ButtonLabel>{label}</ButtonLabel>
      </Button>
      {!!actionMenuOptions.length && (
        <ActionMenu
          align={MENU_ALIGNMENTS.RIGHT}
          direction={MENU_DIRECTIONS.BOTTOM}
          options={actionMenuOptions}
        >
          <IconButton data-test={testIds.actionMenu} size={size} variant={variant}>
            <ChevronDown height={16} width={16} />
          </IconButton>
        </ActionMenu>
      )}
    </ComboButton>
  );
};

export default ActionButtonCombo;
